<template>
  <div class="products-badge" :style="styles">
    <span class="products-badge__text">{{ badgeText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    badgeType: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    styles (): Object {
      return {
        backgroundColor: this.color
      }
    },
    badgeText (): string {
      if (!this.text) return this.$t(`product.${this.translatedName}`)
      return this.text
    },
    translatedName (): string {
      const translations = {
        best_fit: 'bestFit',
        best_price: 'bestPrice',
        best_fit_for_price: 'bestFitForPrice'
      }

      return translations[this.badgeType]
    }
  }
}
</script>

<style src="./badge.scss" />
